import { BroadcastEnum } from 'features/ippica/types';
import styles from './IppicaBroadcast.module.scss';
import { IppicaBroadcastBox } from './ippicaBroadcastBox';
import { Carousel } from 'components/carousel';
import { useGetIppicaBroadcastListQuery } from 'features/api/ippicaApiSlice';

export const IppicaBroadcast = () => {
  const { data } = useGetIppicaBroadcastListQuery();

  return (
    <section className={styles.container}>
      <div className={styles.wrapper}>
        {!!data?.length && (
          <Carousel
            title="Ippica Broadcast"
            cardContainerClassName={styles.ippicaBroadcastCardContainer}
            classNameTitle={styles.title}
          >
            {data.map((item, index) => {
              return (
                <IppicaBroadcastBox
                  key={item.name + '_' + index}
                  type={item.type as BroadcastEnum}
                  label={item.label}
                  name={item.name ?? ''}
                  url={item.url ?? ''}
                  logged={item.logged}
                />
              );
            })}
          </Carousel>
        )}
      </div>
    </section>
  );
};
